import {
  BooleanInput,
  Button,
  FormDataConsumer,
  Form,
  Loading,
  useGetOne,
  useTranslate,
} from 'react-admin';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import ConfirmationMessageField from './shared-components/ConfirmationMessageField';

const DeclineOrderDialog = (props: any) => {
  const {
    record,
    showDeclineDialog,
    toggleDeclineModal,
    handleDeclineSubmit,
  } = props;
  const t = useTranslate();
  const { isLoading, data } = useGetOne('rooms', {
    id: record?.roomId,
  });
  const roomNumber = data ? data.code : null;

  return (
    <Dialog
      fullWidth
      open={showDeclineDialog}
      onClose={toggleDeclineModal}
      onBackdropClick={toggleDeclineModal}
      aria-labelledby="form-dialog-title"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <DialogTitle>
        {isLoading ? (
          <Loading />
        ) : (
          <>
            {t('resources.orders.fields.declinationRecipient')}
            {record.confirmationType === 'push'
              ? ` ${t(
                  'resources.orders.fields.pushConfirmationRecipient'
                )} ${roomNumber}`
              : ` ${record.confirmationRecipient}`}
          </>
        )}
      </DialogTitle>
      <Form>
        <>
          <DialogContent>
            <BooleanInput
              label="resources.orders.notifyGuest"
              source="notifyGuest"
              // eslint-disable-next-line react/jsx-boolean-value
              defaultValue={true}
            />
            <FormDataConsumer>
              {({ formData }) =>
                formData.notifyGuest && (
                  <ConfirmationMessageField
                    response="Declination"
                    source="confirmationMessage"
                  />
                )
              }
            </FormDataConsumer>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={toggleDeclineModal}
              color="inherit"
              size="medium"
              variant="contained"
              label="ra.action.cancel"
            />
            <FormDataConsumer>
              {({ formData }) => (
                <Button
                  sx={{
                    color: '#fff',
                    backgroundColor: '#d84a38',
                    '&:hover': {
                      backgroundColor: '#bb2413',
                    },
                  }}
                  onClick={() => handleDeclineSubmit(formData)}
                  color="primary"
                  size="medium"
                  variant="contained"
                  label="ra.action.decline"
                />
              )}
            </FormDataConsumer>
          </DialogActions>
        </>
      </Form>
    </Dialog>
  );
};

export default DeclineOrderDialog;
